const ACCESS_LOGS_PATH = '/access-logs/collect'
const MAX_URL_LENGTH = 2048
const MAX_REFERER_LENGTH = 2048
const MAX_KEY_LENGTH = 80
const MAX_VALUE_LENGTH = 512
const MAX_QUERY_ENTRIES = 50

function stripControlCharacters (value) {
  return Array.from(value)
    .filter((char) => {
      const code = char.charCodeAt(0)
      return code > 31 && code !== 127
    })
    .join('')
}

function cleanString (value, maxLength = MAX_VALUE_LENGTH) {
  if (value === null || value === undefined) {
    return undefined
  }

  const cleaned = stripControlCharacters(String(value)).trim()
  if (!cleaned) {
    return undefined
  }

  return cleaned.length > maxLength ? cleaned.slice(0, maxLength) : cleaned
}

function cleanKey (key) {
  const cleaned = cleanString(key, MAX_KEY_LENGTH)
  return cleaned && cleaned.length <= MAX_KEY_LENGTH ? cleaned : undefined
}

export function getAccessLogsUrl (apiBaseURL) {
  return new URL(ACCESS_LOGS_PATH, apiBaseURL.replace(/(https:\/\/[^/]+)\1+/, '$1')).toString()
}

export function isAccessLogsUrl (url) {
  return typeof url === 'string' && url.includes(ACCESS_LOGS_PATH)
}

export function sanitizeCookies ($cookies, fallbackCm24Uuid) {
  const cm24Uuid = cleanString($cookies.get('cm24-uuid') || fallbackCm24Uuid, MAX_VALUE_LENGTH)
  return cm24Uuid ? { 'cm24-uuid': cm24Uuid } : {}
}

export function sanitizeQuery (query = {}) {
  const sanitized = {}

  for (const [key, rawValue] of Object.entries(query).slice(0, MAX_QUERY_ENTRIES)) {
    const cleanQueryKey = cleanKey(key)
    if (!cleanQueryKey) {
      continue
    }

    const rawString = Array.isArray(rawValue) ? rawValue.join(',') : rawValue
    const cleanValue = cleanString(rawString, MAX_VALUE_LENGTH)
    if (cleanValue !== undefined) {
      sanitized[cleanQueryKey] = cleanValue
    }
  }

  return sanitized
}

export function buildAccessLogPayload ({ route, query, $cookies, cm24Uuid, referer }) {
  return {
    url: cleanString(route?.fullPath, MAX_URL_LENGTH),
    cookies: sanitizeCookies($cookies, cm24Uuid),
    query: sanitizeQuery(query || route?.query || {}),
    referer: cleanString(referer, MAX_REFERER_LENGTH)
  }
}

export function accessLogRequestConfig (config = {}) {
  return {
    ...config,
    withCredentials: false,
    meta: {
      ...(config.meta || {}),
      suppressGlobalError: true,
      telemetry: 'access-logs'
    }
  }
}
